let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("j9OUx"), load("bV8sS"), load("l079e"), load("kKXTS"), load("hF4v3"), load("afU9w")]).then(() => parcelRequire('iD8My'));